import axios from 'axios';
import JSON_ from 'json_';

export function snakeToCamel(obj) {
  return obj ? JSON_.parse(JSON.stringify(obj)) : obj;
}

export function camelToSnake(obj) {
  return obj ? JSON.parse(JSON_.stringify(obj)) : obj;
}

export function configAxios() {
  axios.interceptors.request.use(config => {
    if (
      config.disableParsing ||
      config.headers['Content-Type'] === 'multipart/form-data'
    ) {
      return config;
    }
    return {
      ...config,
      data: config.data ? camelToSnake(config.data) : config.data,
      params: config.params ? camelToSnake(config.params) : config.params,
    };
  });

  axios.interceptors.response.use(response => {
    if (response.config.disableParsing) {
      return response;
    }
    return {
      ...response,
      data: response.data ? snakeToCamel(response.data) : response.data,
    };
  });
}
